import { RedirectRequest } from "@azure/msal-browser";
import {
    AUTH_AD_NAMES,
    AUTH_CLIENT_IDS,
    ENVIRONMENTS,
} from "./src/common/constants";
import { getEnvironment } from "./src/common/utils";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const getb2cPolicies = () => {
    let adName = AUTH_AD_NAMES.DEVELOPMENT;

    if (getEnvironment() === ENVIRONMENTS.PRODUCTION) {
        adName = AUTH_AD_NAMES.PRODUCTION;
    } else if (getEnvironment() === ENVIRONMENTS.STAGING) {
        adName = AUTH_AD_NAMES.STAGING;
    }

    return {
        names: {
            signUpSignIn: "B2C_1A_SIGNUP_SIGNIN",
            resetPassword: "B2C_1A_PASSWORDRESET",
            editProfile: "B2C_1A_PROFILEEDIT",
        },
        authorities: {
            signUpSignIn: {
                authority: `https://${adName}.b2clogin.com/${adName}.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN`,
            },
            resetPassword: {
                authority: `https://${adName}.b2clogin.com/${adName}.onmicrosoft.com/B2C_1A_PASSWORDRESET`,
            },
            editProfile: {
                authority: `https://${adName}.b2clogin.com/${adName}.onmicrosoft.com/B2C_1A_PROFILEEDIT`,
            },
        },
        authorityDomain: `${adName}.b2clogin.com`,
    };
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const getMsalConfig = () => {
    const b2cPolicies = getb2cPolicies();

    let clientId = AUTH_CLIENT_IDS.DEVELOPMENT;

    if (getEnvironment() === ENVIRONMENTS.PRODUCTION) {
        clientId = AUTH_CLIENT_IDS.PRODUCTION;
    } else if (getEnvironment() === ENVIRONMENTS.STAGING) {
        clientId = AUTH_CLIENT_IDS.STAGING;
    }

    return {
        auth: {
            clientId, // This is the ONLY mandatory field that you need to supply.

            authority: b2cPolicies.authorities.signUpSignIn.authority,
            knownAuthorities: [b2cPolicies.authorityDomain],
            redirectUri: "/",
            postLogoutRedirectUri: "/",
        },
        cache: {
            cacheLocation: "localStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
    };
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
const baseLoginScopes = ["openid", "offline_access"];

export const getLoginRequest = () => {
    let scopes = [...baseLoginScopes];

    if (getEnvironment() === ENVIRONMENTS.PRODUCTION) {
        scopes.push("https://bs360prod.onmicrosoft.com/backend-api/all");
    } else if (getEnvironment() === ENVIRONMENTS.STAGING) {
        scopes.push("https://bs360stag.onmicrosoft.com/backend-api/all");
    } else {
        scopes.push(
            "https://betterspace360dev.onmicrosoft.com/backend-api/all"
        );
    }

    return {
        scopes,
    } as RedirectRequest;
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const getTokenRequest = () => {
    let scopes = [...baseLoginScopes];

    if (getEnvironment() === ENVIRONMENTS.PRODUCTION) {
        scopes.push("https://bs360prod.onmicrosoft.com/backend-api/all");
    } else if (getEnvironment() === ENVIRONMENTS.STAGING) {
        scopes.push("https://bs360stag.onmicrosoft.com/backend-api/all");
    } else {
        scopes.push(
            "https://betterspace360dev.onmicrosoft.com/backend-api/all"
        );
    }

    return {
        scopes,
    } as RedirectRequest;
};
